<template>
    <div class="collection">
        <van-list
            :v-model="loading"
            :finished="finished"
            :finished-text="text"
            @load="onload"
            >
            <van-cell v-for="(item,index) in list" :key="index">
                <cell-list :productInfo="item"></cell-list>
            </van-cell>
        </van-list>
        <div v-if="list.length==0 && finished" class="noImgBox">
            <img class="noImg" src="@/assets/imgs/meiyoushoucang.png" alt="">
        </div>
    </div>
</template>

<script>
import cellList from "@/components/cellList"
export default {
    data() {
        return {

            list:[],
            finished:false,
            loading:false,
            page:1,
            timer:null
        };
    },
    created(){
        document.title='我的收藏'
    },
    methods:{
        onload(){
            if(!this.timer){
                this.timer = setTimeout(() => {
                    this.favoriteList()       //请求列表数据的方法
                    this.timer = null;
                }, 200)
            }
        },
        favoriteList(){
            this.$https.fetchPost("Favorite/index",{"page":this.page},{headers:{"XX-Token":this.$store.state.token}})
            .then(result=>{
                let data=result.data;
                if(data.code==1 && data.data.length!=0){
                    this.list=[...this.list,...result.data.data];
                    this.loading= false;
                    this.page++;
                }else{
                    this.finished= true;
                }
                console.log("收藏列表",this.list);
            })
        },
    },
    components:{
        cellList,
    },
    computed:{
        text(){
            return this.list.length===0 ? '' : "没有更多了"
        }
    }
}
</script>

<style scoped>
  .collection /deep/ .van-cell{
      padding:0;
      background: transparent;
  }
  .noImgBox{
        position: absolute;
        top: 27.6%;
        left: 0;
        right: 0;
        border: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
  }
  .noImg{
      width: 100px;
      height: 126px;
  }
</style>


// WEBPACK FOOTER //
// src/views/commonPage/collection.vue